var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGalery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83317 5H16.2915V12H18.2082V5C18.2082 3.897 17.3485 3 16.2915 3H3.83317C2.77613 3 1.9165 3.897 1.9165 5V17C1.9165 18.103 2.77613 19 3.83317 19H11.4998V17H3.83317V5Z",
    fill: "#00793A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66699 11L4.79199 15H15.3337L11.5003 9L8.62533 13L7.66699 11Z",
    fill: "#00793A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2082 14H16.2915V17H13.4165V19H16.2915V22H18.2082V19H21.0832V17H18.2082V14Z",
    fill: "#00793A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalery);
export default __webpack_public_path__ + "static/media/galery.639f3a15.svg";
export { ForwardRef as ReactComponent };